import { cn } from '@/lib/cn';

export type SegmentOption<T extends string> = {
  value: T;
  label: string;
};

/** Theme-aware segment control. */
export function SegmentedControl<T extends string>({
  value,
  options,
  onChange,
  className,
  size = 'md',
}: {
  value: T;
  options: ReadonlyArray<SegmentOption<T>>;
  onChange: (value: T) => void;
  className?: string;
  size?: 'sm' | 'md';
}) {
  return (
    <div
      role="tablist"
      className={cn(
        'inline-flex gap-0.5 rounded-full border border-makhe-line bg-makhe-paper p-0.5',
        className,
      )}
    >
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.value)}
            className={cn(
              'rounded-full font-medium transition-colors',
              size === 'sm'
                ? 'px-3 py-1 text-[11px] uppercase tracking-widest'
                : 'px-3.5 py-1.5 text-xs',
              active
                ? 'bg-makhe-ink text-makhe-bg'
                : 'text-makhe-muted hover:text-makhe-ink',
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
